import React from "react";
import classNames from "classnames";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Card, CardContent} from "@material-ui/core";
import moment from "moment";
import APPCONFIG from "constants/Config";

export default class Users extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Admins_Locations._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	handleLoginAs = async (e) => {
		const location = parseInt(e.currentTarget.id);
		const account = e.currentTarget.getAttribute('account');

		this.setState({loading: true});

		let dpModel = new API.BuildClass(Types.Admins_Locations._name, API.RequestType.READ);
		dpModel.parent = account;

		dpModel.object.pkey = location;

		try {
			await dpModel.submit(null, API.RequestType.UPDATE, false, false, false, true);
			this.setState({loading: false});
			console.log("logging stuff", APPCONFIG.settings.appURL())
			window.location = APPCONFIG.settings.appURL();
		} catch (e) {
			this.setState({loading: false});
		}
	}

	render() {
		const {data, pages, limit, loading} = this.state;

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Account Locations')}
								<div className="ml-auto refresh">
									<Button color="secondary" onClick={this.reloadTable}><i
										className={"fa fa-refresh"}/></Button>
								</div>
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "",
									className: "button-cell",
									filterable: false,
									sortable: false,
									width: 85,
									Cell: props => {
										return (
											<span>
												<Button
													id={props.original.pkey}
													binary_id={props.original.binary_id}
													account={props.original.accounts.pkey}
													color="green-meadow"
													size={"sm"}
													block={true}
													onClick={this.handleLoginAs}>
													<i className={"fa fa-lock"}/> Login As
												</Button>
											</span>
										);
									}
								},
								{
									Header: "Account",
									id: "account",
									accessor: obj => obj.accounts.pkey,
								},
								{
									Header: "Location Name",
									id: "location_name",
									accessor: obj => obj.name,
								},
								{
									Header: "Name",
									id: "name_first",
									accessor: obj => obj.accounts.name_first + " " + obj.accounts.name_last
								},
								{
									Header: "Email",
									id: "email",
									accessor: obj => obj.email
								},
								{
									Header: "Phone Number",
									id: "phone",
									accessor: obj => obj.phone
								},
								{
									Header: "Street 1",
									id: "street_1",
									/** @param {Admins_Locations_Object} obj */
									accessor: obj => obj.street_1
								},
								{
									Header: "Street 2",
									id: "street_2",
									/** @param {Admins_Locations_Object} obj */
									accessor: obj => obj.street_2
								},
								{
									Header: "City",
									id: "city",
									/** @param {Admins_Locations_Object} obj */
									accessor: obj =>  obj.city
								},
								{
									Header: "State",
									id: "state",
									/** @param {Admins_Locations_Object} obj */
									accessor: obj =>obj.state
								},
								{
									Header: "Zip",
									id: "zip",
									/** @param {Admins_Locations_Object} obj */
									accessor: obj => obj.zip
								},
								// {
								// 	Header: "Subscription",
								// 	id: "description",
								// 	accessor: obj => {
								// 		return (obj.subscription !== null) ? obj.subscriptions.description : ""
								// 	}
								// },
								{
									Header: "Active",
									id: "active",
									accessor: obj => {
										return (obj.subscription !== null) ? ((obj.subscription !== "") ? 'Active' : "") : ""
									}
								},
								{
									Header: "Last Login",
									width: 150,
									id: "last_logged_in",
									accessor: obj => {
										return obj.accounts.last_logged_in ? moment(obj.accounts.last_logged_in).local().format("MM/DD/YYYY h:mm A") : '-'
									}
								},
								{
									Header: "Created",
									id: "created",
									width: 150,
									accessor: obj => {
										return obj.accounts.created ? moment(obj.accounts.created).local().format("MM/DD/YYYY h:mm A") : '-'
									}
								},
							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}